enum ReviewsStatic {
  /**
   * @member {string}
   * @method put
   * @version 2.0
   * @description get reviews
   */
  list = `/v2/reviews`
}

const ReviewsDynamic = {};

export const ReviewsEndpoints = {
  ...ReviewsDynamic,
  ...ReviewsStatic
};

export type ReviewsEndpoints = typeof ReviewsEndpoints;
